import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory, withRouter } from "react-router-dom";
import "react-phone-number-input/style.css";
import "react-toastify/dist/ReactToastify.css";
import ScoreCard from "./Screens/Home/Quiz/ScoreCard";
import { ClientID } from "./GlobalStorage/actions/client.js";
// Screens/Components
import CheckComponentProvider from "./LoadContext";
import Home from "./Screens/Home/Home";
import FullScoreCard from "./Screens/Home/Quiz/FullScoreCard";
import Login from "./Screens/Register/Login";
import ScoreFootball from "./Screens/Home/Quiz/ScoreFootball";
// import Dashboard from "./Screens/Dashboard";
import Starter from "./Screens/Starter/Starter";
import { toast, ToastContainer } from "react-toastify";
import { getUser } from "./API/Auth";
import { useSelector, useDispatch } from "react-redux";
import { addUser } from "./GlobalStorage/actions/user";
import LoadScript from "./LoadScript";
import axios from "axios";
import ReactGA from "react-ga4";
import GoogleAds from "./GoogleAds";

const ProtectedRouts = (props) => {
  let dispatch = useDispatch();
  let history = useHistory();
  let refreshUser = useSelector((state) => state.refreshUser);

  //   console.log(refreshUser)
  useEffect(() => {
    const getClient = async () => {
      let res = await getUser();
      if (res.error == null) {
        dispatch(addUser(res.data.data));
      }
    };
    getClient();
  }, [refreshUser]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Switch>
        <Route path="/home" component={Home} />
        {/* <Route path="/dashboard" component={Dashboard} /> */}
      </Switch>
    </>
  );
};

const App = () => {
  const [loaded, setLoaded] = useState(false);
  let clientid = useSelector((state) => state.clientId);
  let dispatch = useDispatch();
  // console.log(clientid);
  useEffect(() => {
    const scriptLoad = async () => {
      let data = await axios.get("https://cdn.unibots.in/quiz/quiz_new.json");
      let subdomain = window.location.host.split(".")[0];
      let client = data.data[subdomain];
      client = client ? client : data.data["default"];
      let channel = client.id;
      let ga = client.ga;
      let pubId = client.pubid;
      // pubId = "1203149545224208"
      dispatch(ClientID({ pubId }));
      ReactGA.initialize(ga);
      LoadScript(channel, pubId, () => {
        setLoaded(true);
      });
    };
    scriptLoad();
  }, []);

  ReactGA.send({ hitType: "pageview", page: window.location.pathname });

  // useEffect(() => {
  //   let currentURL = window.location.href;
  //   let title, image;
  //   if (currentURL.includes("winacle")) {
  //     title =
  //       "QUIZ: How well do you know Lewis Hamilton, Answer These Question.";
  //     image = "https://unibots.b-cdn.net/eventswidget/quiz/common/racer.jpeg";
  //     var titleMeta = document.createElement("meta");
  //     titleMeta.setAttribute("property", "og:title");
  //     titleMeta.setAttribute("content", title);

  //     var imageMeta = document.createElement("meta");
  //     imageMeta.setAttribute("property", "og:image");
  //     imageMeta.setAttribute("content", image);

  //     document.getElementsByTagName("head")[0].appendChild(titleMeta);
  //     document.getElementsByTagName("head")[0].appendChild(imageMeta);
  //   }
  // }, []);

  return (
    <>
      <CheckComponentProvider>
        <Switch>
          <Route exact path="/" component={Starter} />
          <Route exact path="/starter/:cat" component={Starter} />
          <Route exact path="/t20score/:id" component={ScoreCard} />
          <Route exact path="/footballscore/:id" component={ScoreFootball} />
          <Route path="/login" component={Login} />
          <Route exact path="/scorecard" component={FullScoreCard} />
          <ProtectedRouts />
        </Switch>
      </CheckComponentProvider>
    </>
  );
};

export default App;
